const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

// Addresses are free text, and Intl throws rather than returning undefined on anything it won't
// accept as a region subtag, so an unrecognised code is handed back untouched.
export const formatCountryCode = (countryCode: string): string => {
  try {
    return regionNames.of(countryCode.trim().toUpperCase()) ?? countryCode;
  } catch {
    return countryCode;
  }
};
